/**
 *
 * key
 *
 */

 const key = 'dW5hc3NpZ25lZEVj'

 export default key
 